// extracted by mini-css-extract-plugin
export default {"container":"fMLh1","inPostPage":"vgGXz","noMargin":"Vmohp"};